import { VueApp } from 'larasnap';
import App from './BodyPortal.vue';

export default class extends VueApp {
    static registerAs = 'BodyPortal';

    constructor(element) {
        super(element, App);
    }
}
